/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.OnlineBookingSettings {
    "use strict";

    export class OnlineBookingSettingsContext extends Meevo.Components.CommonClasses.CommonContextBase {

        protected auditNoun: Meevo.Model.NounEnum;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            private $translate: angular.translate.ITranslateService,
            private $scope: angular.IScope,
            protected $q: ng.IQService,
            protected contextParams: Meevo.IContextParams) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

            this.todayDate = moment().startOf("day").toDate();
            // initialize end points
            this.baseEndpoint = appSettings.API_ENDPOINTS.onlineBookingSettings;
            // initialize templatepaths
            this.sectionTemplatePath = "app/plugins/onlineBookingSettings/sectionViews/";
            this.initializeSections();
            if ((identityService.userBusinessTypes.length > 0) || (!identityService.inCentralOfficeMode()))
                this.buildCrudSecurityKeysBase(this.securityKeys.MANAGEMENT_ONLINEBOOKINGSETTINGS_TAB_MAIN);
        }

        canFieldWrite(key): boolean {
            let boop = this.securityChecker.hasSecurity(key + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
            return boop;
        }

        initializeSections(): void {
            // Adding sections items that represent areas in the maintenance form
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_ONLINEBOOKINGSETTINGS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0,
                    "SECTION_ONLINEBOOKINGSETTINGS_MAIN",
                    "main.html",
                    true,
                    false,
                    this.baseEndpoint,
                    "?includeMetadata=true",
                    this.loggingService,
                    this.dataService,
                    Meevo.Model.NounEnum.OnlineBookingSettingMain,
                    this.identityService,
                    this.modalService,
                    this.$scope,
                    this.$q,
                    this.securityChecker,
                    this.securityKeys.REGISTER_MERCHANTACCOUNT_TAB_SURCHARGES + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this.securityKeys.MANAGEMENT_ONLINEBOOKINGSETTINGS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
            if ((this.identityService.inCentralOfficeMode() || this.identityService.current().isSingleLocation) && this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_ONLINEBOOKINGSETTINGS_TAB_ANNOUNCEMENTS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new OnlineBookingAnnouncementsSection(
                    1,
                    'Announcements',
                    'announcements.html', false, false, this.baseEndpoint, "", this.loggingService, this.dataService,
                    Model.NounEnum.OnlineBookingSettingAnnouncements,
                    this.identityService, this.modalService,
                    this.securityKeys.MANAGEMENT_ONLINEBOOKINGSETTINGS_TAB_ANNOUNCEMENTS + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this.contextParams, true
                ));
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_ONLINEBOOKINGSETTINGS_TAB_EMPLOYEES + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new OnlineBookingEmployeesSection(
                    2,
                    'HEADER_EMPLOYEE',
                    'employee.html',
                    false,
                    false,
                    this.baseEndpoint,
                    "",
                    this.loggingService,
                    this.dataService,
                    Model.NounEnum.OnlineBookingSettingEmployees,
                    this.identityService,
                    this.modalService,
                    this.securityKeys.MANAGEMENT_ONLINEBOOKINGSETTINGS_TAB_EMPLOYEES + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                ));
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_ONLINEBOOKINGSETTINGS_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new OnlineBookingServicesSection(
                    3,
                    'SERVICES',
                    'services.html', false, false, this.baseEndpoint, "", this.loggingService, this.dataService,
                    Model.NounEnum.OnlineBookingSettingServices,
                    this.identityService, this.modalService,
                    this.securityKeys.MANAGEMENT_ONLINEBOOKINGSETTINGS_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                ));
            }

            this.activate();
        }

        get securityAccessEnum(): any {
            return Meevo.Model.SecurityAccessEnum;
        }

        selectSection(section: Meevo.Components.CommonClasses.ICommonSection): void {
            if (this.selectedSection && this.selectedSection != section && this.navigationBlocked) {
                this.modalService.alert('MESSAGE_PENDING_CHANGES');
            } else {
                // build security attributes
                super.selectSection(section);
                this.auditNoun = this.selectedSection.noun;
                this.buildCrudSecurityKeysBase(this.selectedSection.sectionSecurityKey.replace(Meevo.Components.Common.SecurityParts.KEY_PART_READ, ''))

            }
        }

        private _obAppUrl: string = '';
        get obAppUrl(): string {
            return this._obAppUrl;
        }
        set obAppUrl(value: string) {
            this._obAppUrl = value;
        }

        private _newObAppUrl: string = '';
        get newObAppUrl(): string {
            return this._newObAppUrl;
        }

        initializeHeader(model: any): void {
            this.headerContent = this.$translate.instant("SECTION_ONLINEBOOKINGSETTINGS_MAIN_HEADER");
            // Get TenantDistribution model and build url
            this.dataService.customMethodData("api/tenant/businessinfo/CustomerPortalUrl", "GET", null)
                .then((result: any) => {
                    this.obAppUrl = result.data.onlineBookingUrl;
                });
        }

        public isCOMode = this.isApplicationModeCO();

        scheduledNotifications() {
            return null;
            //// create grouping for scheduled notifications
            //  let oBookSettingsModel = <Meevo.Model.OnlineBookingSettings>this.selectedSection.model;
            //  return oBookSettingsModel !== undefined
            //      && oBookSettingsModel.communicationTypeNotifications !== undefined
            //      ? oBookSettingsModel.communicationTypeNotifications.filter(i =>
            //    (i.communicationType === Model.CommunicationTypeEnum.AppointmentConfirmation ||
            //              i.communicationType === Model.CommunicationTypeEnum.AppointmentReminderDaysBefore))
            //  : null;
        }

        /**
       * Saves the item currently being edited/added.
       */
        save(): angular.IPromise<any> {
            if ([1, 2].indexOf(this.selectedSection.sectionId) !== -1 && this.canSave) {

                this.selectedSection.preSave();
                super.setMode(Model.MaintenanceFormState.Readonly);
                return;
            }

            return super.save();
        }

        isMSIUser(): boolean {
            return this.identityService.current().userTypeEnum === Model.UserTypeEnum.MSIUser;
        }

    }
}